export default "__VITE_ASSET__CfNx6KSl__"